export enum ResultTypes {
  START_DATE_LOWER_THAN_TODAY,
  START_DATE_HIGGER_THAN_END,
  END_DATE_EQUAL_TO_START_DATE,
  NOT_ALL_PARAMS_ARE_READY,
  ALL_OK
}

export function validateDatePickers(
  startDate: Date | undefined,
  endDate: Date | undefined,
  undefinedEnd: Boolean,
): ResultTypes {

  if (startDate) {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    if (currentDate > startDate) {
      return ResultTypes.START_DATE_LOWER_THAN_TODAY;
    }
  }

  if (startDate && undefinedEnd) {
    // do nothing
  }
  else if (startDate && endDate) {
    if (startDate > endDate) {
      return ResultTypes.START_DATE_HIGGER_THAN_END;
    }
    if (startDate >= endDate) {
      return ResultTypes.END_DATE_EQUAL_TO_START_DATE;
    }
  }
  else {
    return ResultTypes.NOT_ALL_PARAMS_ARE_READY;
  }

  return ResultTypes.ALL_OK;
}
